import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment-timezone";
import ShiftTooltip from "../../../../../components/tooltip/ShiftTooltip";
import { useMenuContext } from "../../../../../hooks/context/useMenuContext";
import { useOpenShiftPreferenceStyle } from "../../../../../hooks/styles/useOpenShiftPreferenceStyle";
import { renderSectionsDuration } from "../../../../../helpers/eventdisplay/renderSectionsDuration";
import { mapOpenShiftRequest } from "../../../../../helpers/data/mapOpenShiftRequest";
import { firstToUpper } from "../../../../../../../../utils/helpers/string";

function OpenShifts({ event }: any) {
    const { t } = useTranslation();
    const userTimezone = moment.tz.guess();
    const { openMenu } = useMenuContext();
    const preferenceStyle = useOpenShiftPreferenceStyle();

    const shift = useMemo(() => mapOpenShiftRequest(event, userTimezone), [event, userTimezone]);

    const onContextMenu = useCallback((e: any) => {
        e.preventDefault();
        e.stopPropagation();
        openMenu({
            id: "open-shift-menu",
            x: e.clientX,
            y: e.clientY + 10,
            selected: shift
        })
    }, [openMenu, shift]);

    return (
        <ShiftTooltip data={{ ...shift, type: "open-shift" }}>
            <div
                className="tw-flex tw-items-center tw-gap-2 tw-border tw-border-dashed tw-rounded-md tw-px-3 tw-py-1 tw-mb-1 tw-cursor-pointer"
                style={preferenceStyle}
                onContextMenu={onContextMenu}
            >
                <span className="tw-text-neutral-900">
                    {renderSectionsDuration(
                        moment(shift.endDate).diff(moment(shift.startDate), "seconds"),
                        shift.sections
                    )}
                </span>

                <span className="tw-text-neutral-900">
                    {firstToUpper(t("open-shift"))}
                </span>
            </div>
        </ShiftTooltip>
    );
}

export default OpenShifts;
